<template>
  <div>
    <div class="body" v-if="show">
      <!-- 每日进度一览 -->
      <div class="title">每日进度一览</div>
      <div class="search">
        <el-date-picker v-model="date" placeholder="选择时间" type="date" value-format="yyyy-MM-dd" @change="dataSpeedList">
        </el-date-picker>
        <a :href="`https://apimanage.rakumart.com/data.dataSpeed.exportMonth?date=${dayDate}& admin_id=${japanUserRoleInfo.id}&admin_id_encrypt=${$md5(japanUserRoleInfo.id + '')}`"
          target="_blank" rel="noopener noreferrer">
          <el-button type="primary">
            历史课内进度导出
          </el-button>
        </a>
        <a :href="`https://apimanage.rakumart.com/data.dataSpeed.exportPersonal?date=${dayDate}& admin_id=${japanUserRoleInfo.id}&admin_id_encrypt=${$md5(japanUserRoleInfo.id + '')}`"
          target="_blank" rel="noopener noreferrer">
          <el-button type="primary">
            每日进度导出
          </el-button>
        </a>
      </div>
      <div class="table">
        <ol>
          <!-- 对应组织 -->
          <li>
            {{ $t('message.correspondingOrganization') }}
          </li>
          <!--  等待采购-->
          <li>
            {{ $t('message.waitingForProcurement') }}
          </li>
          <!--等待改价  -->
          <li>
            {{ $t('message.waitingForChangePrice') }}
          </li>
          <!-- 等待财务付款 -->
          <li>
            {{ $t('message.waitingForFinancialPayment') }}
          </li>
          <!-- 拆包 -->
          <li>
            {{ $t('message.Unpacking') }}
          </li>
          <!-- 上架 -->
          <li>
            {{ $t('message.hitTheShelf') }}
          </li>
          <!--      普检 -->
          <li>
            {{ $t('message.inspection') }}
          </li>
          <!--    精简-->
          <li>
            {{ $t('message.Simplify') }}
          </li>
          <!-- 缝标 -->
          <li>
            {{ $t('message.SeamMarking') }}
          </li>
          <li>
            FBA
          </li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <!-- 对应组织 -->
          <li class="click" @click="listByClass(item)">
            {{ item.class }}
          </li>
          <!--  等待采购-->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.purchase_list">
                <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                  style="margin-left: 0;"> {{ items }} </router-link>
              </p>
              <span slot="reference"> {{ item.purchase }}</span>
            </el-popover>

          </li>
          <!--等待改价  -->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.modify_price_list"><router-link :to="'/orderPaymentDetail?order_sn=' + items"
                  target="_blank" class="a-link" style="margin-left: 0;"> {{ items }} </router-link></p>
              <span slot="reference"> {{ item.modify_price }}</span>
            </el-popover>

          </li>
          <!-- 等待财务付款 -->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.confirm_purchase_list"><router-link :to="'/orderPaymentDetail?order_sn=' + items"
                  target="_blank" class="a-link" style="margin-left: 0;"> {{ items }} </router-link></p>
              <span slot="reference"> {{ item.confirm_purchase }}</span>
            </el-popover>

          </li>
          <!-- 拆包 -->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.unpack_list"><router-link :to="'/orderPaymentDetail?order_sn=' + items"
                  target="_blank" class="a-link" style="margin-left: 0;"> {{ items }} </router-link></p>
              <span slot="reference"> {{ item.unpack }}</span>
            </el-popover>

          </li>
          <!-- 上架 -->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.upstorage_list">
                <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                  style="margin-left: 0;"> {{ items }}
                </router-link>
              </p>
              <span slot="reference"> {{ item.upstorage }}</span>
            </el-popover>

          </li>
          <!--      普检 -->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.inspect_normal_list">
                <router-link :to="'/generalInspectionListDetails?id=' + items" target="_blank" class="a-link"
                  style="margin-left: 0;"> {{ items }}
                </router-link>
              </p>
              <span slot="reference"> {{ item.inspect_normal }}</span>
            </el-popover>

          </li>
          <!--    精简-->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.inspect_careful_list">
                <router-link :to="'/generalInspectionListDetails?id=' + items" target="_blank" class="a-link"
                  style="margin-left: 0;"> {{ items }}
                </router-link>
              </p>
              <span slot="reference"> {{ item.inspect_careful }}</span>
            </el-popover>

          </li>
          <!-- 缝标 -->
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.inspect_label_list">
                <router-link :to="'/generalInspectionListDetails?id=' + items" target="_blank" class="a-link"
                  style="margin-left: 0;"> {{ items }}
                </router-link>
              </p>
              <span slot="reference"> {{ item.inspect_label }}</span>
            </el-popover>

          </li>
          <li>
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="items in item.fba_list">
                <router-link :to="'/porderDetail?porder_sn=' + items" target="_blank" class="a-link"
                  style="margin-left: 0;"> {{ items }}
                </router-link>
              </p>
              <span slot="reference"> {{ item.fba_label }}</span>
            </el-popover>

          </li>
        </ul>
      </div>
    </div>
    <!-- 个人 -->
    <div class="body" v-else>
      <el-button type="primary" @click="show = !show">返回 </el-button>
      <div class="item" v-for="(itemData) in list" :key="itemData.work_name">
        <div class="title">
          {{ itemData.work_name }}
        </div>
        <div class="ByClass" v-if="itemData.work_name == '采购'">
          <ol>
            <!-- 人员 -->
            <li>
              {{ $t('message.personnel') }}
            </li>
            <!--  等待采购-->
            <li>
              {{ $t('message.waitingForProcurement') }}
            </li>
            <!--等待改价  -->
            <li>
              {{ $t('message.waitingForChangePrice') }}
            </li>
            <!-- 等待财务付款 -->
            <li>
              {{ $t('message.waitingForFinancialPayment') }}
            </li>

          </ol>
          <ul v-for="(item, index) in itemData.list" :key="index">
            <!-- 人员 -->
            <li class="click">
              {{ item.realname }}
            </li>
            <!--  等待采购-->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.purchase_top">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.purchase }}</span>
              </el-popover>

            </li>
            <!--等待改价  -->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.modify_price_top">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.modify_price }}</span>
              </el-popover>
            </li>
            <!-- 等待财务付款 -->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.confirm_purchase_top">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.confirm_purchase }}</span>
              </el-popover>
            </li>
          </ul>
        </div>
        <div class="ByClass" v-if="itemData.work_name == '配货'">
          <ol>
            <!-- 人员 -->
            <li>
              {{ $t('message.personnel') }}
            </li>
            <!-- 拆包 -->
            <li>
              {{ $t('message.Unpacking') }}
            </li>
            <!-- 上架 -->
            <li>
              {{ $t('message.hitTheShelf') }}
            </li>
          </ol>
          <ul v-for="(item, index) in itemData.list" :key="index">
            <!-- 人员 -->
            <li class="click">
              {{ item.realname }}
            </li>
            <!-- 拆包 -->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.unpack_top">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.unpack }}</span>
              </el-popover>

            </li>
            <!-- 上架 -->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.upstorage_top">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.upstorage }}</span>
              </el-popover>

            </li>

          </ul>
        </div>
        <div class="ByClass" v-if="itemData.work_name == '检品'">
          <ol>
            <!-- 人员 -->
            <li>
              {{ $t('message.personnel') }}
            </li>
            <!--      普检 -->
            <li>
              {{ $t('message.inspection') }}
            </li>
            <!--    精简-->
            <li>
              {{ $t('message.Simplify') }}
            </li>
            <!-- 缝标 -->
            <li>
              {{ $t('message.SeamMarking') }}
            </li>
            <li>
              FBA
            </li>
          </ol>
          <ul v-for="(item, index) in itemData.list" :key="index">
            <!-- 人员 -->
            <li class="click">
              {{ item.realname }}
            </li>
            <!--      普检 -->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.inspect_normal_top">
                  <router-link :to="'/generalInspectionListDetails?id=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.inspect_normal }}</span>
              </el-popover>

            </li>
            <!--    精简-->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.inspect_careful_top">
                  <router-link :to="'/generalInspectionListDetails?id=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.inspect_careful }}</span>
              </el-popover>

            </li>
            <!-- 缝标 -->
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.inspect_label_top">
                  <router-link :to="'/generalInspectionListDetails?id=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.inspect_label }}</span>
              </el-popover>

            </li>
            <li>
              <el-popover placement="top" width="200" trigger="click">
                <p v-for="items in item.fba_top">
                  <router-link :to="'/porderDetail?porder_sn=' + items" target="_blank" class="a-link"
                    style="margin-left: 0;"> {{ items }}
                  </router-link>
                </p>
                <span slot="reference"> {{ item.fba }}</span>
              </el-popover>

            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
export default {
  data() {
    return {
      show: true,//课或者个人
      date: '',
      tableData: [],
      dayDate: getDate(),
      list: [],
      japanUserRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo'))
    };
  },
  created() {

    this.dataSpeedList()
  },
  methods: {
    dataSpeedList() {
      this.$api.roleApi.dataSpeedList({ date: this.dayDate }).then(res => {
        this.tableData = res.data
      })
    },
    //进度列表统计-个人
    listByClass(item) {
      let datas = {
        class: item.class, date: this.dayDate,
      }

      this.$api.roleApi.listByClass(datas).then(res => {
        this.list = res.data
        this.show = false
      })
    },
    //按个人导出
    exportPersonal() {
      this.$api.roleApi.exportPersonal({ date: this.getDate() }).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'export.xlsx'); // 导出文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.title {
  text-align: left;
}

.table {
  margin: 24px 0;

  .click {
    cursor: pointer;
  }
}

.item {
  margin-top: 24px;
}

.ByClass {


  ol {
    display: flex;
    height: 40px;

    li {
      background-color: #EDEFF4;
    }

  }

  ul {
    display: flex;

    li {
      height: 40px;
      border-bottom: 1px solid #EDEFF4
    }
  }

  li {
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      cursor: pointer;
    }
  }
}

a {
  margin-left: 24px;
}
</style>